// Short sentences joined on the glass. The copy budget (D-425) split long
// refusals into one-sentence keys, and a screen puts them back together. A
// spaced script (English, Russian, French, Hindi) puts one space between
// sentences; Chinese and Japanese do not, because their full stop carries
// the gap, so a bare " " would read as a stray space in zh and zh-Hant.

const UNSPACED: ReadonlySet<string> = new Set(["zh", "ja"]);

export function joinSentences(parts: readonly string[], language: string): string {
  const base = language.toLowerCase().split(/[-_]/u)[0] ?? "";
  return parts.filter((part) => part.length > 0).join(UNSPACED.has(base) ? "" : " ");
}
